/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-19 21:54:17
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-21 23:23:24
 * @FilePath: /mooctest.com/src/api/oss.js
 */

import request from "@/utils/request";
import { t } from "../i18n/i18n";

// eslint-disable-next-line import/prefer-default-export
export function uploadFile(url, fd) {
  return request({
    withCredentials: false,
    timeout: 100000,
    headers: {
      "x-oss-meta-author": "aliy",
      "Content-Type": "application/octet-stream",
    },
    url,
    data: fd,
    method: "put",
    otherOptions: {
      showLoading: true,
      loadingSetting: {
        text: t("common.submitting"),
      },
    },
  });
}
